export default { sha: '40eb478a3bb9429a97cd4735d941b122669e7c14', buildNumber: 'undefined' }
